import { DidomiContext, IsMobile } from 'app/app';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { initializeHome } from 'app/modules/journey/service/step.service';
import { isEndStep } from 'app/modules/journey/service/store/step.selector';
import { AlertDanger } from 'app/shared/components/alert';
import { IRootState } from 'app/shared/reducers';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { failure, loading, RD, SRD, success } from 'srd';
import DesktopHome from './desktop-home/desktop-home';
import './home.scss';
import MobileHome from './mobile-home/mobile-home';


export const Home = () => {

  const didomi = useContext(DidomiContext);
  const isMobile = useContext(IsMobile);

  const { subscriptionNumber, shortOfferCode } = useParams<{ subscriptionNumber: string, shortOfferCode: string }>();
  const dispatch = useDispatch();

  const appStyleCreatedStore = useSelector((state: IRootState) => state.cms.appStyleCreated);
  const isReadyConfigStore = useSelector((state: IRootState) => state.config.isReady)
  const isWithoutOffer = useSelector((state: IRootState) => state.config.isWithoutOffer)

  const errorSubscription = useSelector((state: IRootState) => state.subscription.errorMessage);

  const errorOffers = useSelector((state: IRootState) => state.offers.errorMessage);
  const selectedOffer = useSelector((state: IRootState) => state.offers.selectedOffer);
  const _isEndStep = useSelector(isEndStep);

  const [homeSRD, setHomeSRD] = React.useState<RD<string, string>>(loading())

  useEffect(() => {
    if (appStyleCreatedStore && isReadyConfigStore)
      dispatch(initializeHome(subscriptionNumber, shortOfferCode));
  }, [appStyleCreatedStore, isReadyConfigStore]);


  useEffect(() => {

    if (errorOffers && errorOffers !== '')
      setHomeSRD(failure(errorOffers));
    if (errorSubscription !== '')
      setHomeSRD(failure(errorSubscription));

  }, [errorOffers, errorSubscription]);

  useEffect(() => {
    if (isWithoutOffer) {
      setHomeSRD(success(""));
    }
    if ((selectedOffer && Object.keys(selectedOffer).length > 0 && didomi) || (subscriptionNumber && didomi)) {
      setHomeSRD(success(""));
      if (!_isEndStep) dispatch(gtmEvent('Session ouverte', selectedOffer.code, '0'));
    }
  }, [selectedOffer, didomi]);


  useEffect(() => {
    if (isWithoutOffer) {
      setHomeSRD(success(""));
    }
  }, [isWithoutOffer]);

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div className="app-loading"><div className="lds-dual-ring"></div></div>,
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span><br />{e}</span>}</AlertDanger>,
    success: (d) =>
      <div>
        {isMobile ? <MobileHome /> : <DesktopHome />}
      </div>
  }, homeSRD)

  return view
};

export default Home;
